import {
  useState,
  useEffect,
  Fragment
} from "react";
import { connect } from "react-redux";
import Skeleton from "../../../components/vwSkeleton/vwSkeleton"
import moment from "moment"
import { Link, useLocation, useParams } from "react-router-dom";
import VWModel from '../../../components/vwModal/vwModal';
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Table
} from "reactstrap";
import UITooltip from "../../../CommonData/Data/UITooltip";
import {
  closeCreateGroupModal,
  closeMapNewDeviceModal,
  closeSwitchDetails,
  closeUpdateGroupModal,
  getMasterDeviceDetails,
  openCreateGroupModal,
  openMapNewDeviceModal,
  openSwitchDetails,
  openUpdateGroupModal,
  removeMappedDevice,
  setDeviceId,
  setSelectedGroup,
  updateSelectedDeviceSwitchList
} from "../../../store/deviceDetails/actions";
import {
  CUSTOMER,
  ORGANIZATION_ADMIN,
  RETAILER,
  SUPER_ADMIN,
} from "../../../store/users/role.constants";
import Swal from "../../../CommonData/Data/Swal";
import { groupBy, map } from "lodash";
import CreateGroup from "../Group/CreateGroup";
import EditGroup from "../Group/EditGroup";
import MapGroup from "../Group/MapGroup";
import Message from "../../../CommonData/Data/Message";
import VWLoading from "../../../components/vwLoading/vwLoading";
import "../../FixedColumn.css";
import SwitchDetails from "./SwitchDetails";

const MasterDeviceDetails = (props) => {
  const [swalOptions, setSwalOptions] = useState({
    title: "Are you sure?",
    text: "Do you want to remove the device?",
    icon: "warning",
    buttons: {
      cancel: true,
      confirm: {
        text: "Yes, delete it!",
        value: true,
        visible: true,
        className: "bg-danger",
        closeModal: true,
      },
    },
  });
  const { isGetMasterDeviceDetailsPending, masterDeviceDetails, isMapNewDeviceModalOpen, isCreateGroupModalOpen, isUpdateGroupModalOpen, currentProfile, selectedGroup,
    isOpenSwitchDetails, errorMessage } = props;

  const params = useParams();
  const { id } = params;
  const location = useLocation();
  const queryString = location.pathname;
  const urlParams = queryString && queryString.split("/");
  const reqParams = (urlParams && urlParams.length) > 0 ? urlParams[2] : null;

  useEffect(() => {
    if (id) {
      props.getMasterDeviceDetails(id);
    }
  }, []);

  //----------------------------------ROLES-------------------------------------------------------
  const isRetailer = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0].roleKey === RETAILER;
  const isEndUser = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0].roleKey === CUSTOMER;
  const isAdmin = currentProfile.roles && currentProfile.roles.length > 0 && (currentProfile.roles[0].roleKey === SUPER_ADMIN || currentProfile.roles[0].roleKey === ORGANIZATION_ADMIN);

  //----------------------------------GROUPING DEVICES----------------------------------------------
  var groups = masterDeviceDetails && masterDeviceDetails.assignedDevices &&
    groupBy(masterDeviceDetails.assignedDevices, function (value) {
      return (
        value.group && value.group.name
      );
    });

  const groupedData = map(groups, function (group) {
    return {
      groupName: group[0] && group[0].group && group[0].group.name,
      groupId: group[0] && group[0].group && group[0].group.id,
      groupNo: group[0] && group[0].roomNo,
      devices: group,
    };
  });

  groupedData.sort(function (one, two) {
    return (one.groupId === null) - (two.groupId === null);
  });

  //----------------------------------REMOVE DEVICES----------------------------------------------
  const removeDeviceCallBack = (isConfirm, swal, deviceKey) => {
    const { removeMappedDevice, masterDeviceDetails } = props;
    if (isConfirm) {
      removeMappedDevice(masterDeviceDetails.id, deviceKey, swal);
    }
  };

  //----------------------------------MAP NEW DECICES----------------------------------------------
  const handleCloseMapNewDeviceModal = () => {
    props.closeMapNewDeviceModal();
  };

  const handleOpenMapNewDeviceModal = () => {
    props.openMapNewDeviceModal();
  };

  //----------------------------------CREATE GROUP----------------------------------------------
  const handleOpenCreateGroupModal = () => {
    props.openCreateGroupModal();
  };

  const handleCloseCreateGroupModal = () => {
    props.closeCreateGroupModal();
  };

  //----------------------------------UPDATE GROUP----------------------------------------------
  const handleOpenUpdateGroupModal = (groupId, groupName, groupNo) => {
    props.setSelectedGroup({
      groupId: groupId,
      groupName: groupName,
      groupNo: groupNo,
    });
    props.openUpdateGroupModal();
  };

  const handleCloseUpdateGroupModal = () => {
    props.setSelectedGroup(null);
    props.closeUpdateGroupModal();
  };

  //----------------------------------SWITCH DETAILS----------------------------------------------
  const handleSwitchDetails = (e, id) => {
    e.preventDefault();
    props.openSwitchDetails();
    props.setDeviceId(id);
  }

  const handleCloseSwitchDetails = () => {
    props.closeSwitchDetails();
  }

  const masterDeviceSlaves = masterDeviceDetails && masterDeviceDetails.assignedDevices && masterDeviceDetails.assignedDevices.filter((i) => i.deviceTypeFlag !== "M");
  const masterDeviceSlavesCount = masterDeviceSlaves && masterDeviceSlaves.length;

  return (

    <Fragment>
      <div className="page-content">
        <Card>
          <CardTitle className="p-2 mb-0 d-flex justify-content-between align-items-center fs-5 fw-bold">
            MASTER DETAILS
            <div className="content-heading d-flex gap-3">
              {isRetailer && (
                <div className="ml-auto">
                  <Link
                    type="button"
                    className="mr-1 btn btn-primary btn-sm"
                    // onClick={handleOpenCreateLocker}
                    to="edit"
                  >
                    <em className="far fa-edit me-2"></em>  Edit Device
                  </Link>
                </div>
              )}
              <Link className="btn btn-primary btn-sm" to={reqParams === 'master-devices-customers' ? `/devicelist/master-devices-customers` : `/devicelist/master-devices`}>
                <em className="far fa-times-circle me-2"></em>Back
              </Link>
            </div>
          </CardTitle>
        </Card>
        {errorMessage && (
          <Message
            type="danger"
            defaultMessage={errorMessage}
            baseClassName="alert"
          />
        )}
        {isGetMasterDeviceDetailsPending ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
            <Fragment>
              {/* <VWSpinner height={40} width={40} /> */}
              <VWLoading height={40} width={40} />
              <Skeleton type="base" />
            </Fragment>
          </div>
        ) : (
          masterDeviceDetails && (
            <Row>
              <Col xl="5">
                <Card>
                  <CardTitle className='p-2 fs-6 fw-bold border-bottom'>
                    MASTER DEVICE DETAILS
                  </CardTitle>
                  <div className="table-responsive">
                    <table className="table bb d-table-fixed">
                      <tbody>
                        <tr>
                          <td>
                            <strong>UID</strong>
                          </td>
                          <td>{masterDeviceDetails.uid || "NA"}
                            {!masterDeviceDetails.warningMessage.every(item => item === null) &&
                              <UITooltip id={`warning-${masterDeviceDetails.uid}`} content={masterDeviceDetails.warningMessage?.map((i) => { return i })}>
                                <i class="fas fa-exclamation-triangle text-danger ms-1" style={{ cursor: "pointer" }} />
                              </UITooltip>
                            }
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Friendly Name</strong>
                          </td>
                          <td>{masterDeviceDetails.friendlyName || "NA"}</td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Master Board Serial #</strong>
                          </td>
                          <td>{masterDeviceDetails.boardSerialNumber || "NA"}</td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Allowed No. Of Slave Devices</strong>
                          </td>
                          <td>{masterDeviceDetails.slaveCountToConnect || "NA"}</td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Status</strong>
                          </td>
                          <td>
                            {masterDeviceDetails.isActive ? (
                              <Badge color="success">Active</Badge>
                            ) : (
                              <Badge color="danger">Inactive</Badge>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Customer Name</strong>
                          </td>
                          <td className="text-truncate">
                            {masterDeviceDetails.endCustomerName || "NA"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Assigned By Username</strong>
                          </td>
                          <td className="text-truncate">
                            {masterDeviceDetails.assignedByUserName || "NA"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Assigned By User Email</strong>
                          </td>
                          <td className="text-truncate">
                            {masterDeviceDetails.assignedByUserEmail || "NA"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Valid Till</strong>
                          </td>
                          <td>
                            {moment(masterDeviceDetails.subscriptionValidity).format("DD MMM YYYY")}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Updated By</strong>
                          </td>
                          <UITooltip id="masterDeviceDetailsUpdatedBy" content={masterDeviceDetails.updatedBy}>
                            <td className="text-truncate">
                              {masterDeviceDetails.updatedBy || "NA"}
                            </td>
                          </UITooltip>
                        </tr>
                        <tr>
                          <td>
                            <strong>Updated Date</strong>
                          </td>
                          <td>
                            {masterDeviceDetails.updatedDate ? moment(masterDeviceDetails.updatedDate).format("DD MMM YYYY") : "NA"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {/* end Aside card */}
                </Card>
              </Col>
              <Col xl="7">
                {(isRetailer) && (
                  <div className="mb-3 d-flex">
                    <div>
                      <Button
                        color='primary'
                        size='sm'
                        type="button"
                        onClick={handleOpenCreateGroupModal}
                      >
                        <em className="fas fa-user-plus"></em>     New Group
                      </Button>
                    </div>
                  </div>
                )}
                <Card>
                  <CardTitle className='p-2 fs-6 fw-bold d-flex justify-content-between align-items-center border-bottom'>
                    ASSIGNED DEVICES
                    {isRetailer && (
                      <div className="float-right mt-2 cursor-pointer">
                        <UITooltip id="MapNewDevice" content="Map new device">
                          <a onClick={handleOpenMapNewDeviceModal}>
                            <em
                              className="far fa-plus-square"
                              style={{ fontSize: "20px" }}
                            ></em>
                          </a>
                        </UITooltip>
                      </div>
                    )}
                  </CardTitle>
                  <CardBody>
                    {groupedData &&
                      groupedData.length &&
                      groupedData.map((group, index) => (
                        group.groupName ?
                          <Card key={group.groupId} className="mb-2 border border-secondary">
                            <CardTitle className='d-flex justify-content-between border-bottom border-secondary p-2'>
                              <h6 className="my-2">
                                <span className="fw-bolder text-capitalize">
                                  GROUP :&nbsp;{group.groupName ? group.groupName : "Unassigned"}
                                </span>
                              </h6>
                              {(isEndUser || isRetailer) && group.groupId && (
                                <div className="float-right mt-1 cursor-pointer">
                                  <UITooltip id={`EditGroup_${index}`} content="Edit Group">
                                    <a onClick={() => handleOpenUpdateGroupModal(group.groupId, group.groupName, group.groupNo)}>
                                      <em
                                        className="fa fa-edit fa-fw"
                                        style={{ fontSize: "14px" }}
                                      ></em>
                                    </a>
                                  </UITooltip>
                                </div>
                              )}
                            </CardTitle>
                            {/* <CardBody> */}
                            {group.devices && group.devices.length ? (
                              <div className="list-group border-0">
                                {
                                  <Table className="table table-hover w-100 text-nowrap table-sm fs-6 border-none" responsive>
                                    <thead>
                                      <tr>
                                        <th className="text-center">SERIAL #</th>
                                        <th>NAME</th>
                                        <th className="text-center">SWITCHES</th>
                                        <th>ROOM NAME</th>
                                        <th className="text-center">STATUS</th>
                                        {(isRetailer || isEndUser) ?
                                          <th className="text-center">ACTIONS</th>
                                          :
                                          (isAdmin) && <th>VIEW</th>
                                        }
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {group.devices.map((device, index) => (
                                        <tr key={device.id || "NA"} className="align-middle">
                                          <td align="center">
                                            <div className="d-flex gap-1 justify-content-center">
                                              {device.deviceKey || "NA"}
                                              <div>
                                                {!device.warningMessage.every(item => item === null) &&
                                                  <UITooltip id={`warning-slave-${index}`} content={device.warningMessage?.map((i) => { return i })}>
                                                    <i class="fas fa-exclamation-triangle text-danger" style={{ cursor: "pointer" }} />
                                                  </UITooltip>
                                                }
                                              </div>
                                            </div>
                                          </td>
                                          <td> {device.name || "NA"}
                                            {device.deviceTypeFlag && (
                                              <Fragment>&nbsp;&nbsp;
                                                <sup>
                                                  <UITooltip id={`masterdevice${index}`} content="Master Device">
                                                    <Badge color="primary">{device.deviceTypeFlag}</Badge>
                                                  </UITooltip>
                                                </sup>
                                              </Fragment>
                                            )}
                                          </td>
                                          <td className="text-center">
                                            <div>
                                              <UITooltip id={`totalSwitches${index}`} content="Total Switches">
                                                <Badge color="info">{device.switches.length}</Badge>
                                              </UITooltip>&nbsp;-&nbsp;
                                              <UITooltip id={`enabledSwitches${index}`} content="Enabled Switches">
                                                <Badge className='me-2' color="success">{device.switches && device.switches.filter((i) => i.isEnabled === true).length}</Badge>
                                              </UITooltip>
                                              <UITooltip id={`disabledSwitches${index}`} content="Disabled Switches">
                                                <Badge color="danger">{device.switches && device.switches.filter((i) => i.isEnabled === false).length}</Badge>
                                              </UITooltip>
                                            </div>
                                          </td>
                                          <td>{device.roomName || "NA"}</td>
                                          <td className="text-center">
                                            {device.isActive ? (
                                              <Badge color="success">Active</Badge>
                                            ) : (
                                              <Badge color="danger">Inactive</Badge>
                                            )}
                                          </td>
                                          <td className="text-center sticky-column bg-white">
                                            {(isRetailer || isEndUser) ? (
                                              <div
                                                className="ml-auto me-4"
                                                style={{
                                                  display: "inline-block",
                                                }}
                                              >
                                                <UITooltip id={`EditDevice${index}`} content="Edit Room">
                                                  <Link
                                                    type="button"
                                                    className="ml-auto mr-1"
                                                    to={`${device.id}/update-room`}
                                                  >
                                                    <em className="fa fa-edit fa-fw"></em>
                                                  </Link>
                                                </UITooltip>
                                              </div>
                                            ) : (isAdmin) && (
                                              <Button size="sm" color="link" onClick={(e) => handleSwitchDetails(e, device.id)}>
                                                <em className="far fa-share-square"></em>
                                              </Button>
                                            )}
                                            {isRetailer && (
                                              <div
                                                className="ml-auto cursor-pointer"
                                                style={{
                                                  display: "inline-block",
                                                }}
                                              >{(device.deviceTypeFlag && (masterDeviceSlavesCount !== 0)) ?
                                                <UITooltip id={`RemoveMasterDevice${index}`} content="Device cannot be removed while connected to slaves.">
                                                  <em className="fas fa-trash-alt" style={{ color: "silver" }}></em>
                                                </UITooltip>
                                                :
                                                <Swal
                                                  options={swalOptions}
                                                  callback={(p, swal) =>
                                                    removeDeviceCallBack(
                                                      p,
                                                      swal,
                                                      device.deviceKey
                                                    )}
                                                >
                                                  <UITooltip id={`RemoveDevice${index}`} content="Remove device">
                                                    <em className="fas fa-trash-alt"></em>
                                                  </UITooltip>
                                                </Swal>
                                                }
                                              </div>
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                }
                              </div>
                            ) : (
                              <Fragment>
                                <div style={{ textAlign: "center" }}>
                                  No records found
                                </div>
                              </Fragment>
                            )}
                            {/* </CardBody> */}
                          </Card>
                          :
                          <> {
                            group.devices && group.devices.length ? (
                              <div className="list-group">
                                {group.devices.map((device, index) => (
                                  <Card key={group.groupId} className="mb-2 border border-secondary p-2">
                                    <Table className="table table-hover w-100 text-nowrap table-sm fs-6 border-none" responsive>
                                      <thead>
                                        <tr>
                                          <th className="text-center">SERIAL #</th>
                                          <th>NAME</th>
                                          <th className="text-center">SWITCHES</th>
                                          <th>ROOM NAME</th>
                                          <th className="text-center">STATUS</th>
                                          {(isRetailer || isEndUser) ?
                                            <th className="text-center">ACTIONS</th>
                                            :
                                            (isAdmin) && <th>VIEW</th>
                                          }
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr key={device.id || "NA"}>
                                          <td align="center">
                                            <div className="d-flex gap-1 justify-content-center">
                                              {device.deviceKey || "NA"}
                                              <div>
                                                {!device.warningMessage.every(item => item === null) &&
                                                  <UITooltip id={`warning-slave-${index}`} content={device.warningMessage?.map((i) => { return i })}>
                                                    <i class="fas fa-exclamation-triangle text-danger" style={{ cursor: "pointer" }} />
                                                  </UITooltip>
                                                }
                                              </div>
                                            </div>
                                          </td>
                                          <td>{device.name || "NA"}
                                            {device.deviceTypeFlag && (
                                              <Fragment> &nbsp;&nbsp;
                                                <sup>
                                                  <UITooltip id={`masterdevice${index}`} content="Master Device">
                                                    <Badge color="primary">{device.deviceTypeFlag}</Badge>
                                                  </UITooltip>
                                                </sup>
                                              </Fragment>
                                            )}
                                          </td>
                                          <td className="text-center">
                                            <div>
                                              <UITooltip id={`totalSwitches${index}`} content="Total Switches">
                                                <Badge color="info">{device.switches.length}</Badge>
                                              </UITooltip>&nbsp;-&nbsp;
                                              <UITooltip id={`enabledSwitches${index}`} content="Enabled Switches">
                                                <Badge className='me-2' color="success">{device.switches && device.switches.filter((i) => i.isEnabled === true).length}</Badge>
                                              </UITooltip>
                                              <UITooltip id={`disabledSwitches${index}`} content="Disabled Switches">
                                                <Badge color="danger">{device.switches && device.switches.filter((i) => i.isEnabled === false).length}</Badge>
                                              </UITooltip>
                                            </div>
                                          </td>
                                          <td>{device.roomName || "NA"}</td>
                                          <td className="text-center">
                                            {device.isActive ? (
                                              <Badge color="success">Active</Badge>
                                            ) : (
                                              <Badge color="danger">Inactive</Badge>
                                            )}
                                          </td>
                                          <td className="text-center sticky-column bg-white">
                                            {(isRetailer || isEndUser) ? (
                                              <div
                                                className="ml-auto me-4"
                                                style={{ display: "inline-block" }}
                                              >
                                                <UITooltip id={`EditDevice${index}`} content="Edit Room">
                                                  <Link
                                                    type="button"
                                                    className="ml-auto mr-1"
                                                    to={`${device.id}/update-room`}
                                                  >
                                                    <em className="fa fa-edit fa-fw"></em>
                                                  </Link>
                                                </UITooltip>
                                              </div>
                                            ) : (isAdmin) && (
                                              <Button size="sm" color="link" onClick={(e) => handleSwitchDetails(e, device.id)}>
                                                <em className="far fa-share-square"></em>
                                              </Button>
                                            )}
                                            {isRetailer && (
                                              <div
                                                className="ml-auto cursor-pointer"
                                                style={{ display: "inline-block" }}
                                              >
                                                {(device.deviceTypeFlag && (masterDeviceSlavesCount !== 0)) ?
                                                  <UITooltip id={`RemoveMasterDevice-${index}`} content="Device cannot be removed while connected to slaves.">
                                                    <em className="fas fa-trash-alt" style={{ color: "silver" }}></em>
                                                  </UITooltip>
                                                  :
                                                  <Swal
                                                    options={swalOptions}
                                                    callback={(p, swal) =>
                                                      removeDeviceCallBack(
                                                        p,
                                                        swal,
                                                        device.deviceKey
                                                      )}
                                                  >
                                                    <UITooltip id={`RemoveDevice${index}`} content="Remove device">
                                                      <em className="fas fa-trash-alt"></em>
                                                    </UITooltip>
                                                  </Swal>
                                                }
                                              </div>
                                            )}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </Card>
                                )
                                )}
                              </div>
                            ) : (
                              <Fragment>
                                <div style={{ textAlign: "center" }}>
                                  No records found
                                </div>
                              </Fragment>
                            )}
                          </>
                      ))}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          ))}

        {masterDeviceDetails && (
          <VWModel
            header={`MAP NEW DEVICES`}
            isOpen={isMapNewDeviceModalOpen}
            handleClose={handleCloseMapNewDeviceModal}
          >
            <MapGroup handleClose={handleCloseMapNewDeviceModal} />
          </VWModel>
        )}
        {masterDeviceDetails && (
          <VWModel
            header={`CREATE GROUP`}
            isOpen={isCreateGroupModalOpen}
            handleClose={handleCloseCreateGroupModal}
          >
            <CreateGroup handleClose={handleCloseCreateGroupModal} />
          </VWModel>
        )}
        {masterDeviceDetails && (
          <VWModel
            header={`UPDATE GROUP`}
            isOpen={isUpdateGroupModalOpen}
            handleClose={handleCloseUpdateGroupModal}
          >
            <EditGroup
              selectedGroup={selectedGroup}
              handleClose={handleCloseUpdateGroupModal}
            />
          </VWModel>
        )}
        {masterDeviceDetails && (
          <VWModel
            modalSize="large"
            header={`SWITCH DETAILS`}
            isOpen={isOpenSwitchDetails}
            handleClose={handleCloseSwitchDetails}
          >
            <SwitchDetails
              handleClose={handleCloseSwitchDetails}
            />
          </VWModel>
        )}
      </div >
    </Fragment >

  );
}

const mapStateToProps = (state) => ({
  masterDeviceDetails: state.deviceDetails.masterDevice,
  errorMessage: state.deviceDetails.masterDeviceDetailsError,
  isGetMasterDeviceDetailsPending: state.deviceDetails.isGetMasterDeviceDetailsPending,
  isEditMasterDeviceModalOpen: state.deviceDetails.isEditMasterDeviceModalOpen,
  isMapNewDeviceModalOpen: state.deviceDetails.isMapNewDeviceModalOpen,
  isCreateGroupModalOpen: state.deviceDetails.isCreateGroupModalOpen,
  isUpdateGroupModalOpen: state.deviceDetails.isUpdateGroupModalOpen,
  isUpdateDeviceFriendlyNameModalOpen: state.deviceDetails.isUpdateDeviceFriendlyNameModalOpen,
  currentProfile: state.login.currentProfile,
  selectedGroup: state.deviceDetails.selectedGroup,
  isOpenSwitchDetails: state.deviceDetails.isOpenSwitchDetails,
});

const mapDispatchToProps = (dispatch) => ({
  getMasterDeviceDetails: (masterDeviceId) => dispatch(getMasterDeviceDetails(masterDeviceId)),
  closeMapNewDeviceModal: () => dispatch(closeMapNewDeviceModal()),
  openMapNewDeviceModal: () => dispatch(openMapNewDeviceModal()),
  removeMappedDevice: (masterDeviceId, deviceKey, swal) => dispatch(removeMappedDevice(masterDeviceId, deviceKey, swal)),
  closeCreateGroupModal: () => dispatch(closeCreateGroupModal()),
  openCreateGroupModal: () => dispatch(openCreateGroupModal()),
  closeUpdateGroupModal: () => dispatch(closeUpdateGroupModal()),
  openUpdateGroupModal: () => dispatch(openUpdateGroupModal()),
  updateSelectedDeviceSwitchList: (switches) => dispatch(updateSelectedDeviceSwitchList(switches)),
  setSelectedGroup: (selectedGroup) => dispatch(setSelectedGroup(selectedGroup)),
  openSwitchDetails: (selectedGroup) => dispatch(openSwitchDetails(selectedGroup)),
  closeSwitchDetails: (selectedGroup) => dispatch(closeSwitchDetails(selectedGroup)),
  setDeviceId: (deviceId) => dispatch(setDeviceId(deviceId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MasterDeviceDetails);
